module.exports = __webpack_public_path__ + "img/form.a51fb07a.png";